import { DefaultButton, Spinner, SpinnerSize, TextField } from '@fluentui/react';
import * as S from '../ConvenienceTest/ConvenienceTest.style';
import { useState } from 'react';
import { InputStyles } from '../GlobalStyle';
import { TicketSupportData } from '../../services/TicketSupportService';
import html2canvas from 'html2canvas';
import Auth from '../../Auth/Auth';

type TicketSupportProps = {
    onSupportSend: (data: TicketSupportData) => void;
    showSupportForm: boolean;
    setShowSupportForm: (show: boolean) => void;
    component: string;
    savingPlanId?: string;
    screenName?: string;
    formVal: string;
    financialFormVal: string;
    userIdentity: string;
};

type UserAgentData = {
    platform?: string;
    brands?: { brand: string; version: string }[];
};

const TicketSupport = ({ onSupportSend, showSupportForm, setShowSupportForm, component, savingPlanId, screenName, formVal, financialFormVal, userIdentity }: TicketSupportProps) => {
    const [supportMessage, setSupportMessage] = useState('');
    const [sendingSupportTicket, setSendingSupportTicket] = useState(false); 
    const user = Auth.getUserProfile();
    

const getBrowserInfo = () => {
    const uaData = (navigator as Navigator & { userAgentData?: UserAgentData }).userAgentData;
    const platform = uaData?.platform || navigator.platform;
    const brands = uaData?.brands || [];

    let browserName = 'Unknown';
    let browserVersion = 'Unknown';

    if (brands.length) {
        // Chrome-based (modern)
        const primaryBrand = brands.find(b => b.brand !== 'Not A Brand');
        if (primaryBrand) {
            browserName = primaryBrand.brand;
            browserVersion = primaryBrand.version;
        }
    } else {
        // Legacy detection from userAgent string
        const detected = detectBrowserFromUA(navigator.userAgent);
        browserName = detected.name;
        browserVersion = detected.version;
    }

    return {
        browserName,
        browserVersion,
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform,
    };
};

function detectBrowserFromUA(ua: string): { name: string; version: string } {
    const regexes = [
        { name: 'Edge', regex: /Edg\/([\d\.]+)/ },
        { name: 'Chrome', regex: /Chrome\/([\d\.]+)/ },
        { name: 'Firefox', regex: /Firefox\/([\d\.]+)/ },
        { name: 'Safari', regex: /Version\/([\d\.]+).*Safari/ },
        { name: 'Opera', regex: /OPR\/([\d\.]+)/ },
    ];

    for (const { name, regex } of regexes) {
        const match = ua.match(regex);
        if (match) {
            return { name, version: match[1] };
        }
    }

    return { name: 'Unknown', version: 'Unknown' };
}


    const captureScreenshot = async (): Promise<string | null> => {
        try {
            const canvas = await html2canvas(document.body);
            return canvas.toDataURL('image/png');
        } catch (error) {
            console.error('Error al capturar pantalla:', error);
            return null;
        }
    };

    const handleSendClick = async () => {
        if (!supportMessage.trim()) return;

        setSendingSupportTicket(true);

        const browserInfo = getBrowserInfo();
        const screenshot = await captureScreenshot();
        const path = window.location.pathname;
        const timestamp = new Date().toISOString();

        const supportTicketData = {
            userId: user.id,
            title: `[${screenName}] User: ${user.id}. SavingPlan: ${savingPlanId}. Componente: ${component}`,
            message: supportMessage.trim(),
            browserInfo,
            screenshot,
            path,
            timestamp,
            userIdentity: JSON.stringify(userIdentity),
            formVal: JSON.stringify(formVal),
            financialFormVal: JSON.stringify(financialFormVal)
        };

        try {
            await onSupportSend(supportTicketData);
        } finally {
            setSendingSupportTicket(false);
            setSupportMessage('');
            setShowSupportForm(false);
        }
    };

    const handleCancelClick = () => {
        setSupportMessage('');
        setShowSupportForm(false);
    };

    return (
        <>
            <S.ButtonSupportCont>
                {!showSupportForm && (
                    <DefaultButton
                        disabled={false}
                        className="button tiny-secondary-button support-button"
                        onClick={() => setShowSupportForm(true)}
                    >
                        ¿Necesitas asistencia?
                    </DefaultButton>
                )}

                {showSupportForm && (
                    <S.ButtonSupportFormCont>
                        <S.FielSet>
                            <S.FieldCont>
                                <TextField
                                    className="support-input"
                                    // @ts-ignore
                                    styles={InputStyles}
                                    id="support-message"
                                    name="support-message"
                                    type="text"
                                    label="¿En qué podemos ayudarte?"
                                    style={{ width: '100%' }}
                                    value={supportMessage}
                                    onChange={(e, newValue) => setSupportMessage(newValue || '')}
                                    placeholder="Describe brevemente tu problema..."
                                    multiline={false}
                                    rows={1}
                                    resizable={false}
                                    disabled={sendingSupportTicket}
                                    maxLength={500}
                                />
                            </S.FieldCont>
                        </S.FielSet>
                    </S.ButtonSupportFormCont>
                )}
                {showSupportForm && (
                    <S.SupportButtonContainer>
                        <DefaultButton
                            className="button tiny-primary-button support-button"
                            onClick={handleCancelClick}
                            disabled={sendingSupportTicket}
                        >
                            Cancelar
                        </DefaultButton>
                        <DefaultButton
                            className="button tiny-primary-button support-button"
                            onClick={handleSendClick}
                            disabled={!supportMessage.trim() || sendingSupportTicket}
                        >
                            {sendingSupportTicket && (
                                <Spinner size={SpinnerSize.small} className="button-spinner" />
                            )}
                            {sendingSupportTicket ? 'Enviando...' : 'Enviar'}
                        </DefaultButton>
                    </S.SupportButtonContainer>
                )}
            </S.ButtonSupportCont>

           
        </>
    );
};

export default TicketSupport;
